export default "__VITE_ASSET__FD9o8dsm__"